resourcePaths = '{"rootPath":"","assetsPath":""}';function _ResponsiveLayout() {
    this.init = function() {};

    this.initAllReady = function() {};

    this.registerResponsiveFunction = function(fn, minSize, maxSize) {
        if (mogo.registry.mogoUI.responsiveLayout == undefined)
            mogo.registry.mogoUI.responsiveLayout = new Object();

        if (mogo.registry.mogoUI.responsiveLayout.handler == undefined) {
            mogo.registry.mogoUI.responsiveLayout.handler =
                $(window).on("resize", this._debounce(this._responsiveResize, 250));
        }

        if (mogo.registry.mogoUI.responsiveLayout.arr == undefined) {
            mogo.registry.mogoUI.responsiveLayout.arr = new Array();
        }

        var fn = $.proxy(fn, this);
        if (minSize == null) minSize = 0;
        if (maxSize == null) maxSize = 9999999;
        mogo.registry.mogoUI.responsiveLayout.arr.push({fn:fn, min:minSize, max:maxSize, context: this});

        // override the destroy
        if (!this._originalDestroy) {
            this._originalDestroy = this.destroy || function noop () {};
            this.destroy = function () {
                this.deregisterResponsiveFunctions();
                this._originalDestroy();
            }.bind(this);
        }

        // Run resize on window load
        if (window.mogo.registry.mogoUI.responsiveLayout.initialized == undefined)
            window.mogo.registry.mogoUI.responsiveLayout.initialized = false;
        if (document.readyState != "complete") {
            $(window).load($.proxy(this._responsiveResizeInit, this));
        } else {
            if (!window.mogo.registry.mogoUI.responsiveLayout.initialized)
                this._responsiveResizeInit();
            else {
                var width = $(window).width();
                if (width >= minSize && width <= maxSize)
                    fn(width);
            }
        }
        window.mogo.registry.mogoUI.responsiveLayout.windowWidth = $(window).width();
    };

    this.deregisterResponsiveFunctions = function () {
        var newArray = mogo.registry.mogoUI.responsiveLayout.arr
        .filter(function (el) {
            return el.context !== this;
        }.bind(this));
        mogo.registry.mogoUI.responsiveLayout.arr = newArray;
    };

    this._responsiveResize = function() {
        var width = $(window).width();

        if (!window.mogo.registry.mogoUI.responsiveLayout.initialized ||
            window.mogo.registry.mogoUI.responsiveLayout.windowWidth != width) { // fix for safari triggering resize on scrolling to top of browser

            // Iterate through list of components with _ResponsiveLayout
            for (var i = 0; i < mogo.registry.mogoUI.responsiveLayout.arr.length; i++) {
                var temp = mogo.registry.mogoUI.responsiveLayout.arr[i];
                if (width >= temp.min && width <= temp.max)
                    temp.fn(width);
            }
            window.mogo.registry.mogoUI.responsiveLayout.windowWidth = $(window).width();
        }
        if (!window.mogo.registry.mogoUI.responsiveLayout.initialized)
            window.mogo.registry.mogoUI.responsiveLayout.initialized = true;
    };

    this._responsiveResizeInit = function() {
        if (!window.mogo.registry.mogoUI.responsiveLayout.initialized) {
            this._responsiveResize();
        }
    };

    this._debounce = function(func, wait, immediate) {
      var timeout;
    	return function() {
    		var context = this, args = arguments;
    		var later = function() {
    			timeout = null;
    			if (!immediate) func.apply(context, args);
    		};
    		var callNow = immediate && !timeout;
    		clearTimeout(timeout);
    		timeout = setTimeout(later, wait);
    		if (callNow) func.apply(context, args);
    	};
    };

    this.activeRange = function() {
        this.windowWidth = $(window).width();
        this.smallRange = this.windowWidth >= 0 && this.windowWidth <= window.mogo.registry.mogoUI.config.mediaQueries.small;
        this.mediumRange = this.windowWidth > window.mogo.registry.mogoUI.config.mediaQueries.small && this.windowWidth <= window.mogo.registry.mogoUI.config.mediaQueries.medium;
        this.largeRange = this.windowWidth > window.mogo.registry.mogoUI.config.mediaQueries.medium && this.windowWidth <= window.mogo.registry.mogoUI.config.mediaQueries.large;
        this.xlargeRange = this.windowWidth > window.mogo.registry.mogoUI.config.mediaQueries.large && this.windowWidth <= window.mogo.registry.mogoUI.config.mediaQueries.xlarge;
    };

    this.setActiveViewport = function() {
      var vpContent = this.getActiveViewport();
      this.smallViewport = vpContent === 'small';
      this.mediumViewport = vpContent === 'medium';
      this.largeViewport = vpContent === 'large';
      this.xlargeViewport = vpContent === 'xlarge';
    };

    this.getActiveViewport = function() {
      var _content = window.getComputedStyle(
        document.querySelector('body'), ':before'
      ).getPropertyValue('content');
      return _content.replace(/["']/g, "");
    };

}
